import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CartItem } from '../components/CartItem';
import { Button } from '../components/ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../context/CartContext';
import { ShoppingBag, ArrowRight, ShieldCheck, CreditCard, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Cart() {
  const {
    items,
    removeItem,
    updateQuantity,
    subtotal
  } = useCart();
  const depositTotal = items.reduce((acc, item) => acc + (item.deposit || 0), 0);
  const tax = subtotal * 0.08;
  const serviceCharge = subtotal * 0.2; // 20% gratuity standard for nightlife
  const total = subtotal + tax + serviceCharge;
  return <div className="min-h-screen bg-[#0B1014] text-white flex flex-col" data-id="element-1031">
      <Header data-id="element-1032" />

      {/* Hero Header */}
      <div className="relative pt-32 pb-12 overflow-hidden" data-id="element-1033">
        <div className="absolute inset-0 bg-gradient-to-b from-[#DDA247]/5 via-transparent to-transparent" data-id="element-1034" />
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#DDA247]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-1035" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1036">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1037">
            <div className="flex items-center gap-3 mb-4" data-id="element-1038">
              <ShoppingBag className="w-5 h-5 text-[#DDA247]" data-id="element-1039" />
              <span className="text-sm text-[#DDA247] uppercase tracking-[0.2em] font-medium" data-id="element-1040">
                Your Selection
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white uppercase tracking-tight mb-4" data-id="element-1041">
              Booking Summary
            </h1>
          </motion.div>
        </div>
      </div>

      <main className="flex-1 container mx-auto px-4 md:px-6 pb-20" data-id="element-1042">
        {items.length > 0 ? <div className="flex flex-col lg:flex-row gap-12" data-id="element-1043">
            {/* Cart Items List */}
            <div className="flex-1 space-y-6" data-id="element-1044">
              <AnimatePresence mode="popLayout" data-id="element-1045">
                {items.map(item => <CartItem key={item.id} item={item} onRemove={removeItem} onUpdateQuantity={updateQuantity} data-id="element-1046" />)}
              </AnimatePresence>

              {/* Upsell / Recommendations */}
              <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.4
          }} className="mt-12 pt-12 border-t border-white/10" data-id="element-1047">
                <h3 className="text-lg font-bold uppercase tracking-wide mb-6 flex items-center gap-2" data-id="element-1048">
                  <Sparkles className="w-4 h-4 text-[#DDA247]" data-id="element-1049" />
                  Complete Your Experience
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1050">
                  <Link to="/bottle-service" className="group block bg-[#1A2228] p-4 rounded-lg border border-white/5 hover:border-[#DDA247]/30 transition-all" data-id="element-1051">
                    <div className="flex items-center gap-4" data-id="element-1052">
                      <div className="w-16 h-16 bg-gray-800 rounded overflow-hidden" data-id="element-1053">
                        <img src="https://images.unsplash.com/photo-1597075687490-8f673c6c17f6?w=200&h=200&fit=crop" alt="Champagne" className="w-full h-full object-cover" data-id="element-1054" />
                      </div>
                      <div data-id="element-1055">
                        <h4 className="font-bold text-white group-hover:text-[#DDA247] transition-colors" data-id="element-1056">
                          Add Champagne
                        </h4>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-1057">
                          Pre-order & save 10%
                        </p>
                      </div>
                      <div className="ml-auto" data-id="element-1058">
                        <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-[#DDA247] group-hover:text-black transition-colors" data-id="element-1059">
                          <ArrowRight className="w-4 h-4" data-id="element-1060" />
                        </div>
                      </div>
                    </div>
                  </Link>
                  <Link to="/vip-hosts" className="group block bg-[#1A2228] p-4 rounded-lg border border-white/5 hover:border-[#DDA247]/30 transition-all" data-id="element-1061">
                    <div className="flex items-center gap-4" data-id="element-1062">
                      <div className="w-16 h-16 bg-gray-800 rounded overflow-hidden" data-id="element-1063">
                        <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop" alt="Host" className="w-full h-full object-cover" data-id="element-1064" />
                      </div>
                      <div data-id="element-1065">
                        <h4 className="font-bold text-white group-hover:text-[#DDA247] transition-colors" data-id="element-1066">
                          Dedicated Host
                        </h4>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-1067">
                          Personal concierge service
                        </p>
                      </div>
                      <div className="ml-auto" data-id="element-1068">
                        <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-[#DDA247] group-hover:text-black transition-colors" data-id="element-1069">
                          <ArrowRight className="w-4 h-4" data-id="element-1070" />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </motion.div>
            </div>

            {/* Order Summary */}
            <div className="lg:w-[400px] flex-shrink-0" data-id="element-1071">
              <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="bg-[#1A2228] border border-white/10 rounded-2xl p-6 sticky top-24" data-id="element-1072">
                <h2 className="text-xl font-bold uppercase tracking-wide mb-6 pb-4 border-b border-white/10" data-id="element-1073">
                  Order Summary
                </h2>

                <div className="space-y-4 mb-6" data-id="element-1074">
                  <div className="flex justify-between text-gray-400" data-id="element-1075">
                    <span data-id="element-1076">Subtotal</span>
                    <span className="text-white font-medium" data-id="element-1077">
                      $
                      {subtotal.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-400" data-id="element-1078">
                    <span data-id="element-1079">Service Charge (20%)</span>
                    <span className="text-white font-medium" data-id="element-1080">
                      $
                      {serviceCharge.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-400" data-id="element-1081">
                    <span data-id="element-1082">Taxes</span>
                    <span className="text-white font-medium" data-id="element-1083">
                      $
                      {tax.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                    </span>
                  </div>
                </div>

                <div className="flex justify-between items-end py-4 border-t border-white/10 mb-6" data-id="element-1084">
                  <div data-id="element-1085">
                    <span className="text-sm text-gray-400 uppercase tracking-wider block mb-1" data-id="element-1086">
                      Total
                    </span>
                    {depositTotal > 0 && <span className="text-xs text-[#DDA247]" data-id="element-1087">
                        Due Today: $
                        {depositTotal.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                      </span>}
                  </div>
                  <span className="text-3xl font-bold text-white" data-id="element-1088">
                    $
                    {total.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                  </span>
                </div>

                <Link to="/book-now" data-id="element-1089">
                  <Button fullWidth size="lg" className="mb-4" data-id="element-1090">
                    PROCEED TO CHECKOUT
                  </Button>
                </Link>

                <div className="flex items-center justify-center gap-2 text-xs text-gray-500 mb-6" data-id="element-1091">
                  <ShieldCheck className="w-3 h-3" data-id="element-1092" />
                  <span data-id="element-1093">Secure SSL Encrypted Payment</span>
                </div>

                <div className="bg-white/5 rounded-lg p-4" data-id="element-1094">
                  <h4 className="text-sm font-bold text-white mb-2 flex items-center gap-2" data-id="element-1095">
                    <CreditCard className="w-4 h-4 text-[#DDA247]" data-id="element-1096" />
                    Payment Policy
                  </h4>
                  <p className="text-xs text-gray-400 leading-relaxed" data-id="element-1097">
                    {depositTotal > 0 ? `A deposit of $${depositTotal.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })} is required to secure your reservation. The remaining balance will be due upon arrival at the venue.` : 'Payment will be processed securely. All sales are final.'}
                  </p>
                </div>
              </motion.div>
            </div>
          </div> /* Empty State */ : <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="flex flex-col items-center justify-center py-20 text-center" data-id="element-1098">
            <div className="w-24 h-24 bg-[#1A2228] rounded-full flex items-center justify-center mb-6" data-id="element-1099">
              <ShoppingBag className="w-10 h-10 text-gray-600" data-id="element-1100" />
            </div>
            <h2 className="text-2xl font-bold text-white uppercase tracking-wide mb-2" data-id="element-1101">
              Your Cart is Empty
            </h2>
            <p className="text-gray-400 max-w-md mb-8" data-id="element-1102">
              Looks like you haven't added any experiences yet. Browse our
              exclusive tables and rooms to get started.
            </p>
            <div className="flex gap-4" data-id="element-1103">
              <Link to="/bottle-service" data-id="element-1104">
                <Button variant="outline" data-id="element-1105">Browse Tables</Button>
              </Link>
              <Link to="/book-room" data-id="element-1106">
                <Button data-id="element-1107">View Rooms</Button>
              </Link>
            </div>
          </motion.div>}
      </main>

      <Footer data-id="element-1108" />
    </div>;
}